// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billing-page {
  max-width: 600px;
  padding: 0 4px;
}

.billing-title {
  margin: 0 0 24px;
  font-size: 20px;
  font-weight: 600;
  color: var(--color-primary);
}

.billing-intro {
  margin: -16px 0 24px;
  font-size: 14px;
  color: var(--color-text-secondary);
}

.billing-banner-link {
  color: inherit;
  font-weight: 600;
}

.billing-loading {
  color: var(--color-text-secondary);
  font-size: 14px;
}

.billing-error {
  padding: 10px 14px;
  background: rgba(212, 76, 76, 0.08);
  border: 1px solid rgba(212, 76, 76, 0.25);
  border-radius: 8px;
  color: var(--color-error, #d44c4c);
  font-size: 13px;
  margin-top: 12px;
}

.billing-banner {
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
}

.billing-banner--success {
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #15803d;
}

.billing-banner--info {
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.2);
  color: var(--color-text-secondary);
}

.billing-card {
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.billing-card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.billing-card-label {
  color: var(--color-text-secondary, #6b7280);
}

.billing-card-value {
  font-weight: 500;
  text-transform: capitalize;
}

.billing-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.billing-badge--active {
  background: rgba(34, 197, 94, 0.12);
  color: #15803d;
}

.billing-badge--past-due {
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
}

.billing-badge--canceled-active {
  background: rgba(99, 102, 241, 0.1);
  color: #4338ca;
}

.billing-badge--free {
  background: var(--color-bg-subtle, #f3f4f6);
  color: var(--color-text-secondary, #6b7280);
}

.billing-alert {
  padding: 12px 16px;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 8px;
  color: #92400e;
  font-size: 14px;
  margin-bottom: 20px;
}

.billing-actions {
  margin-top: 8px;
}

.billing-plan-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.billing-plan-prices {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.billing-plan-card {
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 10px;
  padding: 24px;
  background: var(--color-surface, #fff);
}

.billing-plan-name {
  font-size: 18px;
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: 12px;
}

.billing-plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.billing-plan-features li {
  font-size: 14px;
  color: var(--color-text, #111827);
  padding-left: 20px;
  position: relative;
}

.billing-plan-features li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #22c55e;
  font-weight: 700;
}

.billing-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.15s;
}

.billing-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.billing-btn--primary {
  background: var(--color-primary, #6366f1);
  color: #fff;
  width: 100%;
}

.billing-btn--primary:hover:not(:disabled) {
  opacity: 0.88;
}

.billing-btn--secondary {
  background: var(--color-bg-subtle, #f3f4f6);
  color: var(--color-primary, #6366f1);
  border: 1px solid var(--color-border, #e5e7eb);
}

.billing-btn--secondary:hover:not(:disabled) {
  background: var(--color-border, #e5e7eb);
}
`, "",{"version":3,"sources":["webpack://./src/pages/BillingPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".billing-page {\n  max-width: 600px;\n  padding: 0 4px;\n}\n\n.billing-title {\n  margin: 0 0 24px;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-primary);\n}\n\n.billing-intro {\n  margin: -16px 0 24px;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n}\n\n.billing-banner-link {\n  color: inherit;\n  font-weight: 600;\n}\n\n.billing-loading {\n  color: var(--color-text-secondary);\n  font-size: 14px;\n}\n\n.billing-error {\n  padding: 10px 14px;\n  background: rgba(212, 76, 76, 0.08);\n  border: 1px solid rgba(212, 76, 76, 0.25);\n  border-radius: 8px;\n  color: var(--color-error, #d44c4c);\n  font-size: 13px;\n  margin-top: 12px;\n}\n\n.billing-banner {\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.billing-banner--success {\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  color: #15803d;\n}\n\n.billing-banner--info {\n  background: rgba(99, 102, 241, 0.08);\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  color: var(--color-text-secondary);\n}\n\n.billing-card {\n  background: var(--color-surface, #fff);\n  border: 1px solid var(--color-border, #e5e7eb);\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.billing-card-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n}\n\n.billing-card-label {\n  color: var(--color-text-secondary, #6b7280);\n}\n\n.billing-card-value {\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.billing-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.billing-badge--active {\n  background: rgba(34, 197, 94, 0.12);\n  color: #15803d;\n}\n\n.billing-badge--past-due {\n  background: rgba(245, 158, 11, 0.12);\n  color: #b45309;\n}\n\n.billing-badge--canceled-active {\n  background: rgba(99, 102, 241, 0.1);\n  color: #4338ca;\n}\n\n.billing-badge--free {\n  background: var(--color-bg-subtle, #f3f4f6);\n  color: var(--color-text-secondary, #6b7280);\n}\n\n.billing-alert {\n  padding: 12px 16px;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 8px;\n  color: #92400e;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.billing-actions {\n  margin-top: 8px;\n}\n\n.billing-plan-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.billing-plan-prices {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.billing-plan-card {\n  border: 1px solid var(--color-border, #e5e7eb);\n  border-radius: 10px;\n  padding: 24px;\n  background: var(--color-surface, #fff);\n}\n\n.billing-plan-name {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-primary);\n  margin-bottom: 12px;\n}\n\n.billing-plan-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.billing-plan-features li {\n  font-size: 14px;\n  color: var(--color-text, #111827);\n  padding-left: 20px;\n  position: relative;\n}\n\n.billing-plan-features li::before {\n  content: \"✓\";\n  position: absolute;\n  left: 0;\n  color: #22c55e;\n  font-weight: 700;\n}\n\n.billing-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: opacity 0.15s;\n}\n\n.billing-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.billing-btn--primary {\n  background: var(--color-primary, #6366f1);\n  color: #fff;\n  width: 100%;\n}\n\n.billing-btn--primary:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.billing-btn--secondary {\n  background: var(--color-bg-subtle, #f3f4f6);\n  color: var(--color-primary, #6366f1);\n  border: 1px solid var(--color-border, #e5e7eb);\n}\n\n.billing-btn--secondary:hover:not(:disabled) {\n  background: var(--color-border, #e5e7eb);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
